"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Viewer_1 = __importDefault(require("~/components/Cad3d/Viewer"));
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const selectors_1 = require("~/store/selectors");
const useSelectedObjectSize = () => {
    const selectedObjectsUUIDs = (0, react_redux_1.useSelector)(selectors_1.selectSelectedObjectsUUIDs);
    const isImperial = (0, react_redux_1.useSelector)(selectors_1.selectIsImperialMeasurementUsed);
    const [size, setSize] = (0, react_1.useState)(null);
    const objectChangeHandler = () => {
        setSize(Viewer_1.default.instance.getSizeByUUID(selectedObjectsUUIDs[0], isImperial));
    };
    (0, react_1.useMemo)(() => {
        if (selectedObjectsUUIDs.length === 1) {
            setSize(Viewer_1.default.instance.getSizeByUUID(selectedObjectsUUIDs[0], isImperial));
            Viewer_1.default.instance.getDesignProMain().transformControlsInitial.addEventListener('objectChange', objectChangeHandler);
        }
        else {
            setSize(null);
            Viewer_1.default.instance
                .getDesignProMain()
                .transformControlsInitial.removeEventListener('objectChange', objectChangeHandler);
        }
        return () => {
            Viewer_1.default.instance
                .getDesignProMain()
                .transformControlsInitial.removeEventListener('objectChange', objectChangeHandler);
        };
    }, [selectedObjectsUUIDs.length, isImperial]);
    return size;
};
exports.default = useSelectedObjectSize;
